/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import { type Registry as Services, service } from '@ember/service';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  bookingRequest: ModelRegistry['booking-request'];
}

interface BookingRequestGuestCardSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingRequestGuestCardComponent extends Component<BookingRequestGuestCardSignature> {
  @service router!: Services['router'];
  @service session!: Services['session'];

  dateFormat = 'EEE, MMM do';

  @cached
  get bookingRequest(): ModelRegistry['booking-request'] {
    return this.args.bookingRequest;
  }

  @cached
  get canPriceBeFormatted(): boolean {
    return typeof this.price === 'number';
  }

  @cached
  get price(): number | null | undefined {
    const { price } = this.bookingRequest;

    if (!price) {
      return;
    }

    return price.occasionPrice;
  }

  @cached
  get isInboxRoute(): boolean {
    return (this.router.currentRouteName ?? '').includes('inbox');
  }

  @cached
  get baseRoute(): string {
    const base = (this.router.currentRouteName ?? '').includes('monthly')
      ? 'monthly'
      : 'calendar';

    if (this.isInboxRoute) {
      return `${base}.inbox`;
    }

    return base;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::BookingRequest::Guest::Card': typeof UiBookingRequestGuestCardComponent;
  }
}
